import React from 'react';

import { Column } from '@xingternal/xing-grid';

import { JobPostingModule } from '@/components/job-posting-module';
import { ScrollTrackingModuleWrapper } from '@/components/job-posting/components/scroll-tracking-module-wrapper';
import { KununuData } from '@/domain/job-details/components/company-module/employer-actions/employer-types';

import { ModuleTitle } from '../company-module';
import { Benefits } from './benefits';
import { Culture } from './culture';
import { CultureAssessmentCTA } from './culture-assessment-cta';
import { KununuRating } from './kununu';

import * as S from './employer-module.styles';

type Props = {
  companyName: string;
  kununuData: KununuData;
  isCollapsingEnabled: boolean;
};

export const EmployerModule: React.FC<Props> = ({ kununuData, isCollapsingEnabled, companyName }) => {
  const renderKununu = !!kununuData?.culture?.completedSubmissionsCount;
  const hasReportedBenefits = (kununuData.mappedBenefits?.length ?? 0) > 0;

  return (
    <ScrollTrackingModuleWrapper moduleTrackingName="Culture">
      <JobPostingModule>
        <ModuleTitle titleLabel="JOB_DETAILS_KUNUNU_TITLE" />
        <S.StyledContentBanner display="inline" noPadding>
          <S.FullWidthRating>
            <KununuRating kununuData={kununuData} />
          </S.FullWidthRating>
          {hasReportedBenefits ? (
            <S.StyledBenefitsSection>
              <Benefits kununuData={kununuData} isCollapsingEnabled={isCollapsingEnabled} />
            </S.StyledBenefitsSection>
          ) : null}
          {renderKununu && !!kununuData.culture ? (
            <>
              <S.StyledDivider />
              <S.StyledCultureSection data-testid="culture-section">
                <Column size={12}>
                  <Culture companyName={companyName} culture={kununuData.culture} />
                </Column>
              </S.StyledCultureSection>
            </>
          ) : null}
        </S.StyledContentBanner>
        {renderKununu ? <CultureAssessmentCTA /> : null}
      </JobPostingModule>
    </ScrollTrackingModuleWrapper>
  );
};
